module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-success"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "words"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('p', {
    staticClass: "return-home"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goToHome()
      }
    }
  }, [_vm._v("返回首页")])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "success-icon"
  }, [_c('i')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('p', [_vm._v("\n      如有问题任何请联系客服\n    ")]), _vm._v(" "), _c('p', [_vm._v("客服电话: 17621085394")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-72e68da8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckoutSuccess.vue
// module id = 544
// module chunks = 1